import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { formatNumber } from "../../../../../../libs/common";

type dataProp = {
  name: string; // Represents the name, e.g., "JAN"
  uv: number; // Represents the UV value, e.g., 500
};

type DataPoint = { data: dataProp[] };

// Utility function to format large numbers


function LineCharts({ data }: DataPoint) {
  // Custom formatter for Y-axis ticks
  const yAxisFormatter = (value: number) => {
    return formatNumber(value); // Apply the number formatting
  };

  // Custom tooltip for the line chart
  const customTooltip = ({ payload }: any) => {
    if (!payload || payload.length === 0) return null;

    const { uv, name } = payload[0].payload; // Extract the value and the date name
    return (
      <div className="custom-tooltip">
        <p>{`${name}: $${uv.toLocaleString()}`}</p> {/* Format value in USD */}
      </div>
    );
  };

  return (
    <div>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <XAxis dataKey="name" />
          <YAxis tickFormatter={yAxisFormatter} />
          <Tooltip content={customTooltip} />
          <Line type="monotone" activeDot={false} dataKey="uv" stroke="#D52B1E" />
          
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default LineCharts;
